"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_TYPE = void 0;
var DOCUMENT_TYPE;
(function (DOCUMENT_TYPE) {
    DOCUMENT_TYPE["DOC"] = "doc";
    DOCUMENT_TYPE["SHEET"] = "sheet";
    DOCUMENT_TYPE["FORM"] = "form";
    DOCUMENT_TYPE["SLIDE"] = "slide";
    DOCUMENT_TYPE["SMARTSHEET"] = "smartSheet";
    DOCUMENT_TYPE["SMARTCANVAS"] = "smartCanvas";
    DOCUMENT_TYPE["FLOWCHART"] = "flowchart";
    DOCUMENT_TYPE["MIND"] = "mind";
    DOCUMENT_TYPE["PDF"] = "pdf";
})(DOCUMENT_TYPE || (DOCUMENT_TYPE = {}));
exports.DOCUMENT_TYPE = DOCUMENT_TYPE;
